/*
 * Copyright (c) 2021, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { Checkbox, Tooltip } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import MuiAccordion from '@material-ui/core/Accordion';

export const useStyles = makeStyles((theme) => ({
    appBarSpacer: {
        ...theme.mixins.toolbar,
        [theme.breakpoints.down('xs')]: {
            minHeight: theme.spacing(10),
        }
    },
    content: {
        flexGrow: 1,
        height: '100vh',
        overflowY: 'auto',
        ...theme.custom.applicationViewPage.tabs.productionKeys.oAuth.styles
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
        maxWidth: '100%'
    },
    subTitle: {
        ...theme.custom.applicationViewPage.tabs.productionKeys.oAuth.subTitleTextStyles,
        paddingBottom: theme.spacing(1),
    },
    inlineSubTitle: {
        ...theme.custom.applicationViewPage.tabs.productionKeys.oAuth.subTitleTextStyles,
        paddingBottom: 0,
    },
    keyLabel: {
        ...theme.custom.applicationViewPage.tabs.productionKeys.oAuth.contentKeyColor
    },
    flexTextField: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
    },
    multipleLineOptionalFlag: {
        color: theme.palette.grey[500],
    },
    splitKeyLabel: {
        width: '85%',
    },
    accordionSummary: {
        ...theme.custom.applicationViewPage.tabs.productionKeys.oAuth.advancedConfigurationHeader
    },
    accordionDetails: {
        ...theme.custom.applicationViewPage.tabs.productionKeys.oAuth.advancedConfigurationDetails
    },
    StepLabel: {
        color: "#5567d5",
    },
    StepContent: {
        color: '#1D2028',
    },
    tokenBtnText: {
        padding: '10px 15px',
        height: theme.spacing(4),
        textTransform: 'none',
        color: '#5567D5',
        fontSize: '13px',
    },
    table: {
        width: '100%'
    },
    tableIdp: {
        width: '100%',
        marginBottom: theme.spacing(1)
    },
    displayInline: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        paddingLeft: theme.spacing(0.5),
    },
    tableCellBorder: {
        borderWidth: 0,
        paddingLeft: 0,
        padding: 0,
        height: theme.spacing(4.5),
        width: theme.spacing(25),
        paddingRight: theme.spacing(2)
    },
    tableCellBorderNoKeys: {
        borderWidth: 0,
        paddingLeft: '20px',
        padding: '0px',
        height: '36px',
        width: '198px'
    },
    tableCellBorderGrantTypes: {
        borderWidth: 0,
        paddingLeft: 0,
        padding: '0px',
        height: '36px',
        width: '198px',
        paddingRight: '20px',
    },
    tableCellBorderNoKeysGrantTypes: {
        borderWidth: 0,
        paddingLeft: '20px',
        padding: '0px',
        height: '36px',
        width: '198px',
    },
    noKeyDescription: {
        marginTop: theme.spacing(0.7),
        marginBottom: theme.spacing(1.3),
        ...theme.custom.applicationViewPage.tabs.productionKeys.oAuth.noConsumerKeyTextStyle
    },
    td: {
        padding: '8px',
        borderWidth: 0,
        maxWidth: 410
    },
    tdNoKeys: {
        paddingLeft: '30px',
        padding: '8px',
        borderWidth: 0,
        maxWidth: 410
    },
    tdValueCell: {
        padding: '8px',
        borderWidth: 0,
        maxWidth: 'revert',
        width: '430px',
    },
    consumerSecretValue: {
        padding: '0px',
    },
    td2: {
        padding: '0px',
        borderWidth: 0,
        display: 'ruby',
    },
    td2NoKeys: {
        padding: '0px',
        paddingLeft: '30px',
        borderWidth: 0,
        display: 'ruby',
    },
    td1: {
        padding: '1px',
        borderWidth: 0,
    },
    tx: {
        borderWidth: 0,
    },
    grid: {
        width:theme.spacing(90),
    },
    testTokenDescription: {
        marginLeft: 0,
        marginBottom: theme.spacing(2),
        maxWidth: 410,
        ...theme.custom.applicationViewPage.tabs.productionKeys.oAuth.helperTextStyle
    },
    button: {
        marginTop: theme.spacing(3),
        left: 528,
        textTransform: 'capitalize',
        fontFamily: 'GilmerMedium',
        fontSize: theme.spacing(1.625),
        lineHeight: theme.spacing(2),
        color: '#FFFFFF',
        height: theme.spacing(5)
    },
    updateKeyConfigButton: {
        marginTop: theme.spacing(2),
        height: theme.spacing(4),
        padding: theme.spacing(3),
        ...theme.custom.applicationViewPage.tabs.productionKeys.oAuth.updateAdvancedConfigurationsButtonStyles
    },
    genKeysButton: {
        height: theme.spacing(5),
        ...theme.custom.applicationViewPage.tabs.productionKeys.oAuth.generateCredentialsButtonStyle
    },
    genKeysButtonBoxNoKeys: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        width: 0.75,
        paddingLeft: '9px',
    },
    genKeysButtonBox: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        width: 0.75,
        paddingLeft: '24.5px',
    },
    loaderContainer: {
        width: "cal(100%-60px)",
        height: "70%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    componentPadding: {
        paddingLeft: theme.spacing(7),
        paddingRight: theme.spacing(10),
        [theme.breakpoints.down('sm')]: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        },
        [theme.breakpoints.up('lg')]: {
            paddingLeft: 'auto',
            paddingRight: 'auto'
        }
    },
    outlineButtonCell: {
        borderWidth: 0,
        padding: 0,
        paddingTop: '15px',
        width: '150px'
    },
    helperText: {
        marginLeft: 0,
        maxWidth: 410,
        ...theme.custom.applicationViewPage.tabs.productionKeys.oAuth.helperTextStyle
    },
    helperTextWarning: {
        marginLeft: 0,
        maxWidth: 410,
        display: "flex",
        alignItems: "center",
        color: theme.palette.warning.main,
    },
    textField: {
        width: '100%',
        maxWidth: 500,
    },
    textFieldWarning: {
        width: 400,
        maxWidth: 500,
        '& label.Mui-focused': {
            color: theme.palette.warning.main,
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: theme.palette.warning.main,
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: theme.palette.warning.main,
            },
            '&:hover fieldset': {
                borderColor: theme.palette.warning.main,
            },
            '&.Mui-focused fieldset': {
                borderColor: theme.palette.warning.main,
            },
        },
    },
    gridAccordion: {
        maxWidth: 'revert',
        flexBasis: '-moz-available'
    },
    inputLabel: {
        marginTop: '30px'
    },
    warningIcon: {
        height: theme.spacing(2.125),
        width: theme.spacing(2.125),
        marginRight: theme.spacing(1)
    },
    helperTextError: {
        color: '#F44336',
        ...theme.custom.applicationViewPage.tabs.productionKeys.oAuth.errorTextStyle
    },
    tabRoot: {
        ...theme.custom.applicationViewPage.tabs.productionKeys.oAuth.tabs.root
    },
    tabIndicator: {
        ...theme.custom.applicationViewPage.tabs.productionKeys.oAuth.tabs.tabIndicator
    },
    tab: {
        ...theme.custom.applicationViewPage.tabs.productionKeys.oAuth.tabs.tabStyles
    },
    tabTitleText: {
        ...theme.custom.applicationViewPage.tabs.productionKeys.oAuth.tabs.tabTitleTextStyles
    },
    selectedTab: {
        ...theme.custom.applicationViewPage.tabs.productionKeys.oAuth.tabs.selectedTabStyles
    },
    addIdpButton: {
        ...theme.custom.elements.appInfoBar.addButtonStyles,
        ...theme.custom.elements.appInfoBar.outlineButtonStyles,
    },
    cancelClientChangesButton: {
        height: theme.spacing(2.9),
        marginLeft: theme.spacing(2),
        padding: `${theme.spacing(2.9)}px ${theme.spacing(3)}px`,
    },
    selectBox: {
        height: theme.spacing(5),
        width: "100%",
        borderRadius: "5px",
        background: "linear-gradient(180deg, #ffffff 0%, #f7f7f9 100%)",
        boxShadow: "inset 0 0 0 1px #dee0e7, 0 1px 1px 0 rgba(0, 0, 0, 0.06)",
        cursor: "pointer",
        border: 1,
        "&:active": {
            background: "linear-gradient(180deg, #ffffff 0%, #f7f7f9 100%)",
            boxShadow: "inset 0 0 0 1px #a6b3ff, 0 1px 1px 0 rgba(0, 0, 0, 0.06)",
            border: "1px solid #5567d5",
        },
        "&:focused": {
            background: "linear-gradient(180deg, #ffffff 0%, #f7f7f9 100%)",
            boxShadow: "inset 0 0 0 1px #a6b3ff, 0 1px 1px 0 rgba(0, 0, 0, 0.06)",
            border: "1px solid #5567d5 !important",
        },
        "& .MuiSelect-selectMenu": {
            "& .TextSpan": {
                color: '#222228'
            }
        },
    },
    dropdownStyle: {
        backgroundColor: "#fff",
        boxSizing: "border-box",
        width: "auto",
        border: "1px solid #DEE0E7",
        borderRadius: "5px",
        boxShadow: "0 5px 10px -3px rgba(50,50,77,0.1)",
        color: "#222228",
        marginTop: '0.25rem',
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 390,
    },
    idpSelection: {
        minWidth: 390,
    },
    infoIcon: {
        color: '#5567D5',
    },
    idpGrid: {
        textAlign: 'left',
        margin: theme.spacing(0),
        alignSelf: 'center',
    },
    advancedConfigGrid: {
        textAlign: 'left'
    },
    removeMarginTop: {
        marginTop: '0px'
    },
    removeMarginBottom: {
        marginBottom: '0px'
    },
    error: {
        color: '#FF0000',
        fontWeight: 700
    },
    rightAlignedSubTitle: {
        fontSize: '13px',
        letterSpacing: '0',
        lineHeight: '24px',
        paddingTop: '10px',
        paddingBottom: '5px',
        fontFamily: 'Gilmer',
        color: '#222228'
    },
    advancedConfigRightText: {
        textAlign: 'right',
    },
    advancedConfigRaw:{
        marginBottom:theme.spacing(2)
    },
    tokenDocInfo: {
        backgroundColor: '#F0F1FB',
        borderLeftStyle: 'solid',
        borderLeftColor: '#5567D5',
        maxWidth: '500px',
        padding: theme.spacing(1.8),
        margin: theme.spacing(1),
    },
    tokenDocInfoText: {
        fontFamily: 'GilmerMedium',
    },
    urlChip: {
        margin: theme.spacing(0.6)
    },
    permissionBtn: {
        textTransform: 'none',
        color: "#5567D5",
        ...theme.custom.elements.appInfoBar.permissionButtonStyles,
        "&:focus, &:active, &:hover": {
            backgroundColor: "transparent"
        },
    },
    emptyTableCell: {
        border: 0,
        paddingLeft: 0,
        paddingRight: 0
    },
    borderlessTableCell: {
        border: 0,
        padding: 0
    },
    pageTitle: {
        fontSize: "15px",
        textAlign: "left",
        paddingBottom: theme.spacing(3),
        fontFamily: "GilmerMedium",
    },    
    selectBg: {
        width: '100%',
        '& .MuiSelect-select': {
          backgroundColor: '#f7f8fb',
          textAlign: 'left',
          minHeight: theme.spacing(5),
          border: '1px solid #cecece',
          borderRadius: theme.spacing(0.6),
          minWidth: theme.spacing(30),
          alignItems: 'center',
          display: 'flex',
          padding: `${theme.spacing(0.6)}px ${theme.spacing(2.5)}px`,
          fontWeight: 400,
          fontSize: theme.spacing(2),
          margin: 0,
        },
    },
    envBox: {
        display: 'flex',
        alignItems: 'center',
    },
    idpSelectionWrapper: {
        textAlign: 'left',
        marginBottom: theme.spacing(2),
    },
    idpFormWrapper: {
        textAlign: 'left',
        margin: `${theme.spacing(2)}px 0`,
    },
    clientIdInput: {
        width: '100%',
        '& .MuiInputBase-input': {
            padding: `${theme.spacing(1)}px ${theme.spacing(1.7)}px`,
            height: theme.spacing(3.75),
        },
        borderRadius: theme.spacing(2),
    },
    addClientIdBtn: {
        marginLeft: theme.spacing(2),
        height: theme.spacing(6),
        padding: `0 ${theme.spacing(3)}px`,
    },
    endpointsWrapper: {
        textAlign: 'left',
        margin: `${theme.spacing(2)}px 0`,
    },
    endpointWrapper: {
        margin: '8px 0'
    },
    selectedIdpName: {
        fontWeight: 700,
        marginLeft: theme.spacing(2),
        color: '#626262'
    },
    credentialsWrapper: {
        minHeight: theme.spacing(5),
    },
    docsInformation: {
        marginLeft: 0,
        textAlign: "left",
        maxWidth: "inherit",
        width: "inherit",
    },
    docInfo: {
        backgroundColor: "rgb(85 103 213 / 5%)",
        borderLeft: "2px solid #5567D5",
        padding: theme.spacing(2),
        marginBottom: theme.spacing(2),
        width: '100%',
    },
    outlineBtn: {
        padding: theme.spacing(0, 1.7, 0, 2.8),
        marginLeft: theme.spacing(1),
        backgroundSize: theme.spacing(2.5),
    },
    editBtn: {
        ...theme.custom.elements.appInfoBar.editButtonStyles,
        ...theme.custom.elements.appInfoBar.outlineButtonStyles,
        minWidth: theme.spacing(11.25),
    },
    root: {
        width: theme.spacing(50)
    },
    dialogButton: {
        bottom: 50,
        textTransform: 'capitalize',
        fontFamily: 'GilmerMedium',
        fontSize: theme.spacing(1.625),
        lineHeight: theme.spacing(2),
        height: theme.spacing(5)
    },
    dialogRootStyle: {
        borderRadius: theme.spacing(2)
    },
    dialogContent: {
        minWidth: '90%'
    },
    primaryTitle: {
        fontFamily: 'GilmerMedium',
        textAlign: "center",
        fontSize: theme.spacing(2.875),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(2)
    },
    dialogActions: {
        display: "flex",
        justifyContent: "right",
        margin: theme.spacing(8.25,2,1),
        padding: theme.spacing(0.5),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[200]
    },
    editIcon: {
        marginTop: theme.spacing(0.2),
    },
    warningContainer: {
        backgroundColor: '#ffcc8c2b',
        borderLeftStyle: 'solid',
        borderLeftColor: '#FF9D52',
        padding: theme.spacing(1),
        minWidth: 120,
        width: 'fit-content',
        marginBottom: theme.spacing(0.5),
      },
}));

export const DarkTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: '#4caf50',
        color: '#ffffff',
        boxShadow: theme.shadows[2],
        fontSize: 11
    }
}))(Tooltip);

export const CustomCheckbox = withStyles((theme) => ({
    root: {
        '&$checked': {
            color: '#2FA86C'
        }
    },
    checked: {}
}))(Checkbox);

export const NoKeysAccordion = withStyles(() => ({
    root: {
        border: '1px solid #EDEEF1;',
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 0,
        },
        width: '720px',
        '& .MuiAccordionSummary-root': {
            justifyContent: 'flex-start',
            padding: 'unset'
        },
        '& .MuiAccordionSummary-content': {
            padding: '10px',
            marginRight: 'revert',
            paddingRight: '0px',
        },
        '& .MuiAccordionDetails-root': {
            padding: '8px 0px 16px',
        },
        '& .MuiIconButton-root': {  
            marginRight: 'revert',
        },
        '& .MuiAccordionSummary-expandIcon': {
            paddingTop: '19px',
        },
        '& .Mui-expanded.MuiAccordionSummary-expandIcon': {
            paddingTop: '6px',
            paddingBottom: '12px',
        },
    },
    expanded: {},
}))(MuiAccordion);

export const WithKeysAccordion = withStyles((theme) => ({
    root: {
        boxShadow: 'none',
        width: theme.spacing(90),
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 0,
        },
        '& .MuiAccordionSummary-content': {
            flexGrow: 0,
        },
        '& .MuiAccordionSummary-root': {
            justifyContent: 'flex-start',
            padding: 'unset'
        },
        '& .MuiAccordionDetails-root': {
            padding: '8px 0px 16px',
        },
        '& .MuiAccordionSummary-expandIcon': {
            paddingTop: '19px',
        },
        '& .Mui-expanded.MuiAccordionSummary-expandIcon': {
            paddingTop: '5px',
            paddingBottom: '12px',
        },
    },
    expanded: {},
}))(MuiAccordion);
